module.exports = __webpack_public_path__ + "img/igraph-w3.dcb98325.png";